"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionSetModel = void 0;
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const Model_1 = __importDefault(require("../Model"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
class QuestionSetModel extends Model_1.default {
    constructor(o) {
        super(o);
        this.title = '';
        this.titleAlt = {};
        this.form = [];
        this.publishedForm = [];
        this.type = 'unspecified';
        if (o === null || o === void 0 ? void 0 : o.form) {
            try {
                o.form = JSON.parse(o.form || '[]'); //.map(i => new Question(i))
            }
            catch (_a) { }
        }
        super.init(o);
    }
    get __typename() {
        return 'QuestionSet';
    }
    set __typename(v) { }
}
exports.QuestionSetModel = QuestionSetModel;
QuestionSetModel.ALL_FIELDS = `id,
		title,
		titleAlt,
		createdDate,
		form,
		publishedForm,
		lastPublishedDate,
		type`;
exports.default = QuestionSetModel;
ModelRegistry_1.default[DataType_1.default.QUESTIONSET] = QuestionSetModel;
